// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text_us_departments[data-v-1e60feb9] {
  gap: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.text_us_departments_card[data-v-1e60feb9] {
  border-radius: 10px;
}
.text_us_departments_card.disabledContent[data-v-1e60feb9] {
  pointer-events: none !important;
  opacity: 0.9 !important;
}
.text_us_departments_card .cursor_pointer[data-v-1e60feb9] {
  cursor: pointer;
}
.text_us_departments_card small[data-v-1e60feb9] {
  font-size: 15px;
  display: block;
  min-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/AssistantAi/AiComponents/AiTextUsDepartments.vue","webpack://./AiTextUsDepartments.vue"],"names":[],"mappings":"AACA;EACE,SAAA;EACA,aAAA;EACA,qCAAA;ACAF;ADGA;EACE,mBAAA;ACDF;ADGE;EACE,+BAAA;EACA,uBAAA;ACDJ;ADJA;EASI,eAAA;ACFJ;ADPA;EAaI,eAAA;EACA,cAAA;EACA,gBAAA;ACHJ","sourcesContent":["\n.text_us_departments {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.text_us_departments_card {\n  border-radius: 10px;\n\n  &.disabledContent {\n    pointer-events: none !important;\n    opacity: 0.9 !important;\n  }\n\n  .cursor_pointer {\n    cursor: pointer;\n  }\n\n  small {\n    font-size: 15px;\n    display: block;\n    min-height: 20px;\n  }\n\n}\n",".text_us_departments {\n  gap: 15px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n.text_us_departments_card {\n  border-radius: 10px;\n}\n.text_us_departments_card.disabledContent {\n  pointer-events: none !important;\n  opacity: 0.9 !important;\n}\n.text_us_departments_card .cursor_pointer {\n  cursor: pointer;\n}\n.text_us_departments_card small {\n  font-size: 15px;\n  display: block;\n  min-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
